import type { FormFieldDto } from '../../form.types';
import { CHOICE_CONTROL_CLASS } from './field.styles';

interface FormFieldRadioProps {
    field: FormFieldDto;
}

export function FormFieldRadio({ field }: FormFieldRadioProps) {
    return (
        <div className="form-choice-group md:col-span-2">
            {field.choices?.map((choice) => (
                <label key={choice.value} className="form-choice">
                    <input
                        type="radio"
                        name={field.name}
                        value={choice.value}
                        defaultChecked={choice.value === field.options?.defaultValue}
                        className={CHOICE_CONTROL_CLASS}
                    />
                    <span>{choice.label}</span>
                </label>
            ))}
        </div>
    );
}
